<template>
	<div class="container-fluid pb-3" style="padding-top: 56px">
		<b-row
			class="position-sticky shadow-sm bg-white py-2"
			style="top: 56px; z-index: 4"
		>
			<b-col class="my-1">
				<nearby-stores @change="getItems" />
			</b-col>
		</b-row>
		<b-row
			class="align-items-center position-sticky shadow-sm bg-white py-3 mb-3"
			:style="{
				top: '143px',
				zIndex: 3,
			}"
		>
			<b-col md="3">
				<h5 class="text-capitalize  mb-0">
					{{ $t('categories') }}
				</h5>
			</b-col>
			<b-col md="9">
				<div class="d-flex align-items-center">
					<div class="flex-grow-1">
						<b-input-group>
							<template #prepend>
								<b-input-group-text>
									<b-icon-search />
								</b-input-group-text>
							</template>
							<b-form-input v-model="filters.query" :placeholder="$t('typeSearchItems')" @input="searchItems" />
							<b-input-group-append>
								<client-only>
									<b-dropdown :text="$t('sort by')" variant="primary" right size="sm">
										<b-dropdown-item
											v-for="(sort, index) in sortingList"
											:key="index"
											:active="filters.order_by === sort.value.order_by && filters.dir === sort.value.dir"
											@click="filters = Object.assign({}, filters, sort.value)"
										>
											<b-icon :icon="sort.icon" />
											{{ $t(`sortOptions.${sort.label}`) }}
										</b-dropdown-item>
									</b-dropdown>
								</client-only>
							</b-input-group-append>
						</b-input-group>
					</div>
					<div
						v-if="merchant.settings.general.catalog && merchant.settings.general.catalog.food_type_filter"
						class="ml-3"
					>
						<b-form-select
							v-model="filters.food_type"
							class="text-capitalize"
							@change="searchItems()"
						>
							<b-form-select-option v-for="(option, index) in foodTypeFilter" :key="index" :value="option.value">
								{{ $t(option.label) }}
							</b-form-select-option>
						</b-form-select>
					</div>
				</div>
			</b-col>
			<b-col md="12" class="p-0 mt-3">
				<b-breadcrumb class="mb-0">
					<b-breadcrumb-item
						:active="validSelectedCategories.length === 0"
						class="text-capitalize"
						@click.prevent="validSelectedCategories.length > 0 ? onPressCategoryBack(0) : null"
					>
						{{ $t('all categories') }}
					</b-breadcrumb-item>
					<template v-if="validSelectedCategories.length > 0">
						<b-breadcrumb-item
							v-for="(c, i) in validSelectedCategories"
							:key="c.id"
							class="text-capitalize"
							:active="i >= validSelectedCategories.length - 1"
							@click.prevent="i < validSelectedCategories.length - 1 ? onPressCategoryBack(i + 1) : null"
						>
							{{ locale === 'en' ? c.name : (c.alternate_language || c.name) }}
						</b-breadcrumb-item>
					</template>
					<b-col
						v-if="selectedStore?.min_order_value"
						md="auto"
						class="d-flex align-items-center justify-content-end ml-auto"
					>
						<p class="m-0">
							{{ $t('deliveryMinOrderValue') }}: <b>{{ toCurrency(selectedStore.min_order_value) }}</b>
						</p>
					</b-col>
				</b-breadcrumb>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="3">
				<div class="position-sticky overflow-auto" style="top: 290px; height: calc(100vh - 300px)">
					<b-list-group v-if="!loading.categories">
						<b-list-group-item
							v-for="(c, index) in categories.data"
							:key="index"
							:active="selectedCategories.length ? selectedCategories[selectedCategories.length - 1].id === c.id : c.id === null"
							href="#"
							class="text-capitalize py-2"
							@click="selectCategory(c)"
						>
							<p class="my-0">
								{{ locale === 'en' ? c.name : (c.alternate_language || c.name) }}
							</p>
							<b-icon
								v-if="c.child_categories_count"
								icon="chevron-right"
								class="position-absolute"
								style="top: 50%; right: 2px; transform: translateY(-50%)"
							/>
						</b-list-group-item>
					</b-list-group>
					<div v-else class="text-center p-3">
						<b-spinner variant="primary" label="Loading categories..." />
					</div>
					<div
						v-if="!loading.categories && categories.pagination && categories.pagination.current_page < categories.pagination.next_page"
						v-observe-visibility="(isVisible) => loadMoreResults(isVisible, 'categories', 'getCategories')"
						class="d-flex justify-content-center my-3"
					>
						<b-spinner v-if="loadingMoreCategories" :label="$t('loadItems')" />
					</div>
				</div>
			</b-col>
			<b-col md="9">
				<b-row v-if="!isLoading && items.data.length">
					<b-col
						v-for="(item, itemIndex) in items.data"
						:key="itemIndex"
						md="3"
						class="mb-3"
					>
						<item-card :item="item" />
					</b-col>
				</b-row>
				<div
					v-else-if="isLoading"
					class="h-100 d-flex justify-content-center align-items-center"
					style="min-height: 300px"
				>
					<b-spinner variant="primary" label="Loading..." />
				</div>
				<div
					v-else
					class="h-100 d-flex justify-content-center align-items-center"
					style="flex-direction: column"
				>
					<img src="/images/no-result.svg" height="150px">
					<h5
						class="text-capitalize"
					>
						{{ $t('noItemsFound') }}!
					</h5>
				</div>
				<div
					v-if="items.pagination && items.pagination.current_page < items.pagination.next_page"
					v-observe-visibility="(isVisible) => loadMoreResults(isVisible, 'items', 'getItems')"
					class="d-flex justify-content-center my-3"
				>
					<b-spinner v-if="loadingMore" :label="$t('loadItems')" />
				</div>
			</b-col>
		</b-row>
		<b-alert
			v-if="selectedStore"
			v-model="isSelectedStoreInactive"
			class="position-fixed fixed-bottom text-center rounded-0 m-0"
			style="z-index: 2000"
			variant="danger"
		>
			{{ nextStartTimeMessage }}
		</b-alert>
	</div>
</template>

<script>
	import ItemCard from '@/components/item-card'
	import NearbyStores from '@/components/nearby-stores'

	export default {
		name: 'Items',
		components: {
			ItemCard,
			NearbyStores
		},
		middleware: ['nearby-store', 'category'],
		asyncData ({ store, query }) {
			return store.dispatch('getItems', {
				category_ids: query.category_id ? [query.category_id] : [],
				dir: 1
			}).then((response) => {
				return {
					items: {
						data: response.data.items,
						pagination: response.data.pagination,
						filters: response.data.filters
					}
				}
			}).catch(() => {})
		},
		data () {
			return {
				timer: null,
				isLoading: false,
				loadingMore: false,
				loadingMoreCategories: false,
				loading: {
					categories: false
				},
				notifyStoreClosed: false,
				sortingList: [
					{
						label: 'AZ',
						icon: 'sort-alpha-down',
						value: {
							order_by: 'name',
							dir: 1
						}
					},
					{
						label: 'ZA',
						icon: 'sort-alpha-down-alt',
						value: {
							order_by: 'name',
							dir: -1
						}
					},
					{
						label: 'LH',
						icon: 'sort-numeric-down',
						value: {
							order_by: 'price',
							dir: 1
						}
					},
					{
						label: 'HL',
						icon: 'sort-numeric-down-alt',
						value: {
							order_by: 'price',
							dir: -1
						}
					},
					{
						label: 'remove sort',
						icon: 'x-circle',
						value: {
							order_by: '',
							dir: 1
						}
					}
				],
				filters: {
					query: '',
					category_ids: [],
					order_by: '',
					dir: 1,
					food_type: null
				},
				loadingPage: null
			}
		},
		head () {
			return {
				title: `${this.merchant.business.name} | ${this.$options.filters.capitalize(this.$tc('item', 2))}`
			}
		},
		computed: {
			foodTypeFilter () {
				const filter = this.items.filters.find(filter => filter.filter_type === 'food_type')

				return filter?.values.length ? filter.values : []
			},
			merchant () {
				return this.$store.state.merchant
			},
			locale () {
				return this.$store.state.locale
			},
			location () {
				return this.$store.state.location
			},
			user () {
				return this.$store.state.user
			},
			selectedStore: {
				get () {
					return this.$store.state.selectedStore
				},
				set (store) {
					this.$store.commit('setSelectedStore', store)
				}
			},
			isSelectedStoreInactive () {
				return !this.selectedStore.available || this.notifyStoreClosed
			},
			categories () {
				return this.$store.state.categories
			},
			cart: {
				get () {
					return this.$store.state.cart
				},
				set (value) {
					this.$store.commit('setState', { key: 'cart', value })
				}
			},
			cartItemsIndex () {
				return this.cart.items.reduce((items, item, index) => {
					if (this.cart.store && this.cart.store.id === this.selectedStore.id) {
						items[item.id] = {
							index,
							quantity: item.quantity
						}
					}

					return items
				}, {})
			},
			validSelectedCategories () {
				return this.selectedCategories.filter(c => c.id !== null)
			},
			category () {
				let category = { id: null, name: 'all' }

				if (this.validSelectedCategories.length) {
					category = this.validSelectedCategories[this.validSelectedCategories.length - 1]
				}

				return category
			},
			nextStartTimeMessage () {
				const nextOpeningTime = this.storeNextOpeningTime(this.selectedStore)

				return nextOpeningTime ? `Online Orders have Closed at ${this.selectedStore.name}. ${nextOpeningTime}` : `Online Orders have Closed at ${this.selectedStore.name}`
			},
			selectedCategories: {
				get () {
					return this.$store.state.selectedCategories
				},
				set (value) {
					this.$store.commit('setState', {
						key: 'selectedCategories',
						value
					})
				}
			}
		},
		watch: {
			filters () {
				this.scrollTo(0)
				this.getItems()
			},
			selectedStore (value) {
				if (value) {
					this.notifyStoreClosed = !!this.getTodayNextOpeningTime(value)
				}
			}
		},
		mounted () {
			if (this.$route.query.category_id) {
				this.filters.category_ids = [+this.$route.query.category_id]
				this.selectCategory(this.categories.data.find(c => c.id === +this.$route.query.category_id), false)
			} else if (this.selectedCategories.length && (this.selectedCategories[this.selectedCategories.length - 1]?.id || this.selectedCategories[this.selectedCategories.length - 2]?.id)) {
				const lastCategory = this.selectedCategories[this.selectedCategories.length - 1]
				const parentCategory = this.selectedCategories.length > 1 ? this.selectedCategories[this.selectedCategories.length - 2] : null

				if (parentCategory && parentCategory.id) {
					this.getCategories({ parent_id: parentCategory.id })
				}

				if (lastCategory.id || parentCategory.id) {
					this.filters.category_ids = [lastCategory.id || parentCategory.id]
					this.getItems()
				}
			}

			if (this.selectedStore) {
				this.notifyStoreClosed = !!this.getTodayNextOpeningTime(this.selectedStore)
			}
		},
		methods: {
			getTodayNextOpeningTime (store) {
				const now = this.$moment()
				const day = (now.format('dddd') || '').toLowerCase()
				const timings = store?.timings?.[day] || []

				for (const timing of timings) {
					if (!timing?.start_time || !timing?.end_time) { continue }

					const start = this.$moment(timing.start_time, 'HH:mm')

					const end = this.$moment(timing.end_time, 'HH:mm')

					if (now.isBetween(start, end)) {
						return false
					}
				}

				return true
			},
			getCategories (filters = {}) {
				const isPagination = Number.isInteger(filters.page)

				if (isPagination && this.loadingMoreCategories) { return }

				if (isPagination) {
					this.loadingMoreCategories = true
				} else {
					this.loading.categories = true
				}

				filters = Object.assign({
					active: true
				}, filters)

				return this.$store.dispatch('getCategories', filters)
					.catch(this.showErrors)
					.finally(() => {
						if (isPagination) {
							this.loadingMoreCategories = false
						} else {
							this.loading.categories = false
						}
					})
			},
			loadMoreResults (isVisible, entity, functionName) {
				if (isVisible && this[entity].pagination && this[entity].pagination.current_page < this[
					entity
				].pagination.next_page && this.loadingPage !== this[entity].pagination.next_page) {
					this.loadingPage = this[entity].pagination.next_page
					this[functionName]({ page: this[entity].pagination.next_page })
				}
			},
			async selectCategory (category, itemFlag = true) {
				if (category.id) {
					// Find the category from the categories data
					let selectedCategory = this.categories.data.find(c => c.id === category.id)

					if (!selectedCategory) {
						await this.getCategories()
						selectedCategory = this.categories.data.find(c => c.id === category.id)
					}

					if (selectedCategory && selectedCategory.parent_id) {
						const parentCategory = this.categories.data.find(c => c.id === selectedCategory.parent_id)

						if (parentCategory) {
							this.selectedCategories = [
								{ id: null, name: 'all' },
								parentCategory,
								selectedCategory
							]
						}
					} else {
						this.selectedCategories = [...this.selectedCategories.slice(0, -1), this.categories.data.find(c => c.id === category.id)]
					}

					if (category.child_categories_count > 0) {
						await this.getCategories({ parent_id: category.id })
						this.selectedCategories = [...this.selectedCategories, { id: null, name: 'all' }]
					}
				} else {
					const parentCategory = this.selectedCategories[this.selectedCategories.length - 2]

					if (parentCategory && parentCategory.id) {
						this.selectedCategories = [...this.selectedCategories.slice(0, -1), { id: null, name: 'all' }]
					} else {
						this.selectedCategories = [{ id: null, name: 'all' }]
					}
				}

				if (itemFlag) {
					this.filters = {
						...this.filters,
						category_ids: this.category?.id ? [this.category.id] : []
					}
					this.items.pagination = {}
				}
			},
			getItems (filters = {}) {
				clearTimeout(this.timer)
				const isPagination = Number.isInteger(filters.page)

				if (isPagination) {
					this.loadingMore = true
				} else {
					this.isLoading = true
				}

				this.timer = setTimeout(() => {
					filters = Object.assign({}, this.filters, filters)
					this.$store.dispatch('getItems', filters).then((response) => {
						this.items.data = filters.page ? this.items.data.concat(response.data.items) : response.data.items
						this.items.pagination = response.data.pagination
						this.items.filters = response.data.filters
					}).catch((err) => {
						this.showErrors(err)
					}).finally(() => {
						this.loadingPage = null

						if (isPagination) {
							this.loadingMore = false
						} else {
							this.isLoading = false
						}
					})
				}, 500)
			},
			async onPressCategoryBack (index) {
				const isRootCategory = index === 0

				this.selectedCategories = isRootCategory
					? [{ id: null, name: 'all' }]
					: [...this.selectedCategories.slice(0, index)]

				const targetCategory = isRootCategory ? null : this.selectedCategories[index - 1]

				await this.getCategories(
					targetCategory?.id ? { parent_id: targetCategory.id } : {}
				)

				await this.getItems({ category_ids: this.category?.id ? [this.category.id] : [] })
			},
			searchItems () {
				clearTimeout(this.timer)
				this.filters = Object.assign({}, this.filters)
				this.timer = setTimeout(() => {
					const searchFilters = {
						query: this.filters.query,
						category_ids: this.category?.id ? [this.category.id] : [],
						order_by: this.filters.order_by,
						dir: this.filters.dir,
						food_type: this.filters.food_type
					}

					this.getItems(searchFilters)
				}, 500)
			}
		}
	}
</script>
